import { SuccessPaginationResponseType, SuccessResponseType } from "./main";

export enum TagType {
    DOCUMENT = 0,
    COST = 1,
    EMPLOYEE_WORK_INFO = 2,
}

export interface TagDataCreate {
    name: string;
    type: TagType;
}

export interface TagData {
    id: number | string;
    name: string;
    type: TagType;
    deleted_at?: string | null;
    created_at: string;
    updated_at: string;
}

export interface TagsSuccessResponse extends SuccessPaginationResponseType<Array<TagData>> {}

export interface TagSuccessResponse extends SuccessResponseType<TagData> {}
